import { createSearchRequest } from "../../hooks/useSearchRequest";
import { getCompanies, getBundles } from "../../repository/data.repository";
import { DynamicSchema } from "../../controls/DynamicForm.default";
import { retry } from "../../utils/http";
import { QueryOperation } from "../../code/search-query/search-query";
import { nameOf } from "../../utils/typescript";
import { Company } from "../../repository/data.default";

/**
 * Shared Company / Bundle pickers + the `company · bundle · created/updated` search schema used by
 * BOTH the Bundles Assignments and Test Groups grids (and their dialogs) — they were byte-for-byte
 * duplicated across those surfaces.
 */
export const companiesRequest = createSearchRequest(getCompanies, "name");
export const bundlesRequest = createSearchRequest(getBundles, "name");

/** Company picker that also surfaces the tenant as a sub-label (for the grant/assignment dialog). */
export const companiesRequestWithTenant = (search: string) =>
  retry(() =>
    getCompanies({
      searchQuery: {
        conditions: [
          {
            field: nameOf<Company>("name"),
            operation: QueryOperation.StartsWith,
            values: [search],
          },
        ],
      },
      pageNumber: 0,
      pageSize: 100,
    }),
  ).then(({ data }) =>
    data.map((dataItem) => ({
      display: dataItem.name,
      subDisplay: dataItem.tenantName,
      value: dataItem.uid,
      dataItem,
    })),
  );

/** The shared search-form schema for the company-scoped Bundles grids (Assignments + Test Groups). */
export const bundleScopedSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "combobox", name: "company", label: "Company", request: companiesRequest },
        { type: "combobox", name: "bundle", label: "Bundle", request: bundlesRequest },
        { type: "textbox", name: "createdByUserUserName", label: "Created by" },
        { type: "rangetimepicker", name: "createdOn", label: "Created On" },
        { type: "textbox", name: "updatedByUserUserName", label: "Updated by" },
        { type: "rangetimepicker", name: "updatedOn", label: "Updated On" },
      ],
    },
  ],
};
